import React from 'react'
import { useEnvValue } from '@morningtrain/react-helpers'
import { SquareButton } from 'ui/buttons'
import * as Icons from 'ui/icons'

function InventoryOrderDaysAdjuster (props) {
  const [weekdays, setWeekdays] = useEnvValue('globals.inventory.delivery_days.weekdays', [])
  const [extraWeekdays, setExtraWeekdays] = useEnvValue('globals.inventory.delivery_days.extra_weekdays', [])
  const [closedWeekdays] = useEnvValue('globals.inventory.delivery_days.closed_weekdays', [])

  const handleRemove = () => {
    const tempWeekdays = [...weekdays]
    const tempExtraWeekdays = [...extraWeekdays]

    if (tempWeekdays.length > 1) {
      const dayBeingRemoved = tempWeekdays.splice(-1)
      tempExtraWeekdays.unshift(dayBeingRemoved)
      if(closedWeekdays.includes(dayBeingRemoved)) {
        tempExtraWeekdays.unshift(tempWeekdays.splice(-1))
      }
      addSelectedDayIfBeforeClosedDay(tempWeekdays, tempExtraWeekdays)

      setWeekdays([...tempWeekdays])
      setExtraWeekdays([...tempExtraWeekdays])
    }
  }

  const handleAdd = () => {
    const tempWeekdays = [...weekdays]
    const tempExtraWeekdays = [...extraWeekdays]

    if (tempExtraWeekdays.length >= 1) {
      const dayToAdd = tempExtraWeekdays.shift()
      tempWeekdays.push(dayToAdd)

      addSelectedDayIfBeforeClosedDay(tempWeekdays, tempExtraWeekdays)

      setWeekdays([...tempWeekdays])
      setExtraWeekdays([...tempExtraWeekdays])
    }
  }

  const addSelectedDayIfBeforeClosedDay = (weekdays, extraWeekdays) => {
    const nextDay = extraWeekdays[0]

    if(closedWeekdays.includes(nextDay)) {
      weekdays.push(extraWeekdays.shift())
      addSelectedDayIfBeforeClosedDay(weekdays, extraWeekdays)
    }
  }

  return (
    <>
      <SquareButton color='btn-lightgray' onClick={handleRemove}>
        <Icons.Minus className='w-3' />
      </SquareButton>
      <SquareButton color='btn-lightgray' onClick={handleAdd}>
        <Icons.Plus className='w-3' />
      </SquareButton>
    </>
  )
}

export default InventoryOrderDaysAdjuster
